import * as tslib_1 from "tslib";
import { Command } from './command';
import { ToolHelper } from '../utility/index';
var MenuItem = /** @class */ (function (_super) {
    tslib_1.__extends(MenuItem, _super);
    function MenuItem(param) {
        var _this = _super.call(this, param) || this;
        var obj;
        if (typeof param === 'string') {
            obj = JSON.parse(param);
        }
        else {
            obj = param;
        }
        if (!obj) {
            return _this;
        }
        _this.contents = [];
        var keys = 'contents';
        Object.keys(obj).forEach(function (key) {
            if (keys.includes(key)) {
                obj[key].forEach(function (item) {
                    var domObj = ToolHelper.createObjectByType(item.type);
                    if (domObj) {
                        _this.contents.push(new domObj(item));
                    }
                });
            }
        });
        return _this;
    }
    MenuItem.prototype.toJSON = function () {
        var result = [];
        if (this.contents && this.contents.length) {
            this.contents.forEach(function (item) {
                result.push(item.toJSON());
            });
        }
        return Object.assign({}, _super.prototype.toJSON.call(this), { "contents": result, "type": "MenuItem" });
    };
    MenuItem.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return MenuItem;
}(Command));
export { MenuItem };
//# sourceMappingURL=menu_item.js.map